import { Transforms } from 'slate';
import { CustomEditor, EmbedBlockFormat, ImageElement, VideoElement } from 'components/_new/NewSlateEditor/types';
import { createParagraph } from './paragraph';

export const createEmbedNode = (type: EmbedBlockFormat, { url, alt }: { url: string; alt?: string }) =>
	({
		type,
		alt,
		url,
		width: 400,
		widthUnit: 'px',
		float: undefined,
		children: [{ text: '' }],
	} as ImageElement | VideoElement);

export const insertEmbed = (
	editor: CustomEditor,
	embedData: { url: string; alt?: string },
	format: EmbedBlockFormat
) => {
	const { url } = embedData;
	if (!url) {
		return;
	}
	const embed = createEmbedNode(format, embedData);

	Transforms.insertNodes(editor, embed);
	Transforms.insertNodes(editor, createParagraph(''), { select: true });
};
